import { Stack } from '@mantine/core'
import type { MaintenanceLogWithRelations } from '@markku/types'
import { AttachmentsCard } from './AttachmentsCard'
import { CompletedStepsCard } from './CompletedStepsCard'
import { CostSummaryCard } from './CostSummaryCard'
import { LogSummaryCard } from './LogSummaryCard'

interface MaintenanceLogDetailProps {
  log: MaintenanceLogWithRelations
}

export function MaintenanceLogDetail({ log }: MaintenanceLogDetailProps) {
  return (
    <Stack gap="lg">
      <LogSummaryCard log={log} />
      <CostSummaryCard log={log} />
      <CompletedStepsCard log={log} />
      <AttachmentsCard log={log} />
    </Stack>
  )
}
